const UserRoles = {
    OUTAGEOPSROLE: 'Operations',
    OUTAGESCHEDULING: 'Scheduling',
  OUTAGELOGISTICSROLE: 'Asset Logistics',
  OUTAGEREADONLYROLE: 'ReadOnly',
  OutageControlCenter: 'Control Center',
  SOXAUDITPRICINGADMIN: 'SOXAuditPricingAdmin',
  SOXMARKETINGREPRESENTATIVE: 'SOXMarketingRepresentative',
  SOXAUDITREPORTROLE: 'SOXAuditReportRole',
  DIGMASTERTRACKERREADONLY: 'DigMasterTrackerReadOnly',
  DIGMASTERTRACKERREADWRITE: 'DigMasterTrackerReadWrite',
  DIGMASTERTRACKERADMINROLE: 'DigMasterTrackerAdminRole',
  SpotPriceReadOnly: 'SpotPriceReadOnly',
  TowerTargetsReadOnly: 'TowerTargetsReadOnly'
};

export default UserRoles;